let elements = {
  /**direction type:
  auto
  top
  bottom
  left
  right
  topleft
  topright
  bottomleft
  bottomright
  lefttop
  leftbottom
  righttop
  rightbottom
  **/

  mainImage: {
    imagePath: 'games/page030_game10/img/bcg.jpg',
    width: 1430,
    height: 910,
    pos: {
      x: 379,
      y: 138,
    },
  },
  activeArea: {
    width: 50,
    height: 50,
    fontSize: 35,
    backgroundColor: '#f36f1a',
    color: '#ffffff',
  },
  items: [
    {
      id: '1',
      animation: true,
      // direction: 'left',
      textObj: {
        text: 'Kliknij w przycisk <i>Kształty</i> i wybierz ikonę narzędzia <i>Owal.  </i>',
      },
      audio: {
        src: 'games/page030_game10/audio/z15s30-1.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 1388,
        y: 362,
      },
    },
    {
      id: '2',
      // direction: 'left',
      textObj: {
        text: 'Rysuj koło, trzymając wciśnięty klawisz Shift.  ',
      },
      audio: {
        src: 'games/page030_game10/audio/z15s30-2.mp3',
        //icon: {
        // audioOn: 'assets/on.png',
        // audioOff: 'assets/off.png',
        //},
        // position: 'top',
      },
      pos: {
        x: 1028,
        y: 472,
      },
    },
  ],
};
export default elements;
